<div class="bil-gst-upload-modal">
<div class="modal-header bil-font-regular">
    <span class="header-label">How to download GST
        Return Report</span>
    <span class="close-btn" (click)="onConfirmClick()">
        <img src="../../../../assets/images/smallclose.svg" />
    </span>
</div>
<div class="bil-font-regular modal-div-container bil-font-regular">
    <div class="bil-gst-report-steps">
        <span class="step-label steps-heading">Follow the steps below to download GST Return Report</span>
    </div>
    <div class="bil-gst-report-steps">
        <div class="step-no">1</div>
        <div class="step-label">Login to the GST portal <a href="#" class="bil-report-link">https://www.gst.gov.in/</a></div>
    </div>
    <div class="bil-gst-report-steps">
        <div class="step-explain">
            <div class="step-no">2</div>
            <div class="step-label">Then, go to <b>'Services'</b> > <b>'Returns'</b> > <b>'Returns Dashboard'</b></div>
        </div>
        <img mat-card-image src="../../../../assets/images/gstReportImages/bitmap_2020-01-18 (1)/bitmap.png"
            alt="Photo">
    </div>
    <div class="bil-gst-report-steps">
        <div class="step-explain">
            <div class="step-no">3</div>
            <div class="step-label">Select the <b>Month</b> and <b>Year</b> from the drop-down.</div>
        </div>
        <img mat-card-image calss="report-image"
            src="../../../../assets/images/gstReportImages/bitmap_2020-01-18 (2)/bitmap.png" />
    </div>
    <div class="bil-gst-report-steps">
        <div class="step-explain">
            <div class="step-no">4</div>
            <div class="step-label">Click <b>'PREPARE OFFLINE'</b> under <b>GSTR 1..</b></div>
        </div>
        <img mat-card-image calss="report-image"
            src="../../../../assets/images/gstReportImages/bitmap_2020-01-18 (3)/bitmap.png" />
    </div>
    <div class="bil-gst-report-steps">
        <div class="step-explain">
            <div class="step-no">5</div>
            <div class="step-label">Go to <b>'Download'</b> and click on <b>'GENERATE FILE'</b>.</div>
        </div>
        <img mat-card-image calss="report-image"
            src="../../../../assets/images/gstReportImages/bitmap_2020-01-18/bitmap.png" />
    </div>
</div>
</div>